import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
export const RedirectToStripe = ({ redirectFn }) => {
    useEffect(redirectFn('custom_account_verification'), []);
    return _jsx(FormattedMessage, { id: "EditListingWizard.redirectingToStripe" });
};
